import React from "react";
import useSortList from "./useSortList";

type Props = {};

const useFilterItem = (event: string, inputData: any, sortKey?: string) => {
  let result = inputData;
  result = result?.filter((item: any) => {
    return item.name.toLowerCase().search(event.toLowerCase()) !== -1;
  });
  if (sortKey) {
    result = useSortList(result, sortKey)
  }
  return [result];
};

export default useFilterItem;
